import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
// import { Helpers } from '../../../helpers';
import { UserService } from '../../../auth/_services';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit, OnDestroy {
    s: any = null;
    user_name = "Anonymous";
    user_email = "";

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.s = this.userService.loggedIn.subscribe(
            result => {
                this.load();
            }
        );
        this.load();
    }

    load() {
        let user = UserService.getUser();

        if (user) {
            this.user_name = user.firstname || "";
            this.user_email = user.userid || "";
        }
    }

    ngAfterViewInit() {
        mLayout.initHeader();
    }

    ngOnDestroy() {
        if (this.s) this.s.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts